import { UserLanguage } from '../../features/account/types/User'
import { LanguageMap } from '../../types/LanguageMap'
import { internalApiserverApi } from './internal-apiserver'

export type LanguageMaps = Record<UserLanguage, LanguageMap>

// Only the listed groups and entries are written; everything else in the maps is kept.
export type LanguageMapsUpdate = Partial<Record<UserLanguage, Record<string, Record<string, object>>>>

const languageApi = internalApiserverApi.enhanceEndpoints({ addTagTypes: ['languageMaps'] }).injectEndpoints({
  endpoints: (builder) => ({
    getLanguageMaps: builder.query<LanguageMaps, void>({
      query: () => 'language',
      providesTags: ['languageMaps'],
    }),
    updateLanguageMaps: builder.mutation<void, LanguageMapsUpdate>({
      query: (update) => ({ url: 'i/language/maps/update', method: 'PUT', body: update }),
      invalidatesTags: ['languageMaps'],
    }),
  }),
})

export const { useGetLanguageMapsQuery, useUpdateLanguageMapsMutation } = languageApi
